import { Icon, IconsEnum } from 'components/Icons';

import { AnchorLink } from 'components/anchorLink';
import { DynamicImage, enLoading } from 'components/Image';
import { ImageProps } from 'next/legacy/image';
import { RichText } from 'components/richText';
import { isNotEmpty } from 'utility/functions';
import styles from './CardApp.module.scss';
import { useGetLabelByKey } from 'hooks/useLingUI';
import useWindowSize from 'hooks/useWindowSize';

export type CardAppProps = {
  image: ImageProps;
  title: string;
  description: string;
  urlDonwloadAppAndroid?: string;
  urlDonwloadAppAndroidLabel?: string;
  urlDonwloadAppIos?: string;
  hasWrapper?: boolean;
  className?: string;
  qrCode?: ImageProps;
};

export const CardApp = ({ ...props }: CardAppProps) => {
  const {
    image,
    title,
    description,
    urlDonwloadAppAndroid,
    urlDonwloadAppAndroidLabel,
    urlDonwloadAppIos,
    hasWrapper,
    className,
    qrCode,
  } = props;
  const donwloadAppAndroidLabel = useGetLabelByKey('disponibile-per');

  const { isMobile } = useWindowSize();

  return (
    <div className={` ${hasWrapper ? styles.hasWrapper : ''} ${className ? className : ''}`}>
      <div className={styles.headingContainer}>
        {isNotEmpty(image?.src) && (
          <DynamicImage
            src={`${image?.src}`}
            alt={image.alt ?? ''}
            title={image.title}
            width={48}
            height={48}
            loading={enLoading.lazy}
            decoding="async"
            layout={'fixed'}
          />
        )}
        <div className={styles.title}>{title}</div>
      </div>
      {title && <hr className={styles.hr} />}
      <RichText containerClassName={styles.description}>{description}</RichText>
      <div className={styles.donwloadAppContainer}>
        <div className={styles.donwloadAppLinkContainer}>
          {urlDonwloadAppAndroid && (
            <AnchorLink href={urlDonwloadAppAndroid} className={styles.donwloadAppAndroidContainer}>
              <span className={styles.donwloadAppAndroidLabel}>{donwloadAppAndroidLabel}</span>
              <span className={styles.urlDonwloadAppAndroidLabel}>{urlDonwloadAppAndroidLabel}</span>
            </AnchorLink>
          )}
          {urlDonwloadAppIos && (
            <AnchorLink href={urlDonwloadAppIos} className={styles.urlDonwloadAppIos}>
              <Icon iconId={IconsEnum.DOWNLOAD_APPLE} className={styles.urlDonwloadAppIosImage} />
            </AnchorLink>
          )}
        </div>
        {!isMobile && isNotEmpty(qrCode?.src) && (
          <div className={styles.qrCodeContainer}>
            <span className={styles.donwloadAppAndroidLabel}>SCARICALA subito</span>
            <div className={styles.qrCode}>
              <DynamicImage
                src={`${qrCode?.src}`}
                alt={qrCode?.alt ?? ''}
                title={qrCode?.title ?? ''}
                width={48}
                height={48}
                loading={enLoading.lazy}
                decoding="async"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
